<template>
  <div v-show="show" class="step">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'step',
  computed: {
    show() {
      let index = this.$parent.$children.indexOf(this)
      let step = this.$parent.step - 1
      return index === step
    }
  }
}
</script>

<style lang="scss" scoped>
.step {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.step-title {
  background: url('../img/step-title.png') no-repeat;
  background-size: 100% 100%;
  height: 72px;
  line-height: 72px;
  padding: 0 72px;
  font-size: 28px;
  color: #ffffff;
  margin-top: -78px;
  margin-bottom: 24px;
}
p {
  font-size: 30px;
  line-height: 48px;
  text-align: center;
  em {
    font-style: normal;
    color: #e64827;
  }
}
select {
  border: 1px solid #f8e8cf;
  outline: none;
  -webkit-appearance: none;
  width: 440px;
  height: 72px;
  line-height: 72px;
  padding: 0 24px;
  overflow: hidden;
  border-radius: 14px;
  font-size: 32px;
  background: url('../img/icon-arrow-down.png') #ffffff no-repeat;
  background-size: 22px 14px;
  background-position: 390px 28px;
  margin-top: 30px;
  margin-bottom: 20px;
}
.step-detail {
  white-space: pre-line;
  font-size: 26px;
  height: 600px;
  padding-right: 10px;
  position: relative;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/cs180824/components/step.vue